<div class="container-fluid footer-container">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-12">
        <div class="logo-container">
          <div class="rg-logo logo">
            <img src="assets/images/rg-logo.svg" alt="">
          </div>
          <span class="separator"></span>
          <div class="ubc-logo logo">
            <img src="assets/images/ubc-logo.svg" alt="">
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-12">
        <div class="footer-group">
          <div class="footer-box">
            <h6 class="footer-links-label">Machine Learning & AI </h6>
            <div class="footer-links-group">
              <a href="#" target="_blank" class="footer-link">Blog</a>
              <a href="#" target="_blank" class="footer-link">News</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-12">
        <div class="footer-group">
          <div class="footer-box">
            <h6 class="footer-links-label">University of British Columbia</h6>
            <div class="footer-links-group">
              <a href="#" target="_blank" class="footer-link">UBC Extended Learning</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-12">
        <div class="footer-group">
          <div class="footer-box">
            <h6 class="footer-links-label">RoboGarden Inc</h6>
            <div class="footer-links-group">
              <a href="#" target="_blank" class="footer-link">About</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 bottom-row">
        <p class="copyrights">RoboGarden Inc. © {{ currentYear }}</p>
        <div class="social-links-container">
          <a *ngFor="let link of socialLinks" [href]="link.link" target="_blank" class="social-link">
            <img [src]="link.img" [alt]="link.name">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
